import { render, staticRenderFns } from "./CreateCourseModal.vue?vue&type=template&id=21dce0ca&"
import script from "./CreateCourseModal.vue?vue&type=script&lang=js&"
export * from "./CreateCourseModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateCourseModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports